import React, { Component } from 'react';
import { FormGroup, ControlLabel, FormControl } from 'react-bootstrap';
import ReactSelect from 'react-select';
import 'react-select/dist/react-select.css';
import FormError from '../../../forms/FormError';
import { getAssetsByType } from '../../../../api/api';

const getValidationState = meta => {
  if (meta.touched) {
    if (meta.valid === false) {
      return 'error';
    }
    if (meta.warning) {
      return 'warning';
    }
    if (meta.valid === true) {
      // return 'success';
    }
  }
  return null;
};

const getRelationshipType = field => {
  const { opts } = field || {};

  const { relationshipType } = opts || {};

  return relationshipType;
}

const getRelationshipField = field => {
  const { opts } = field || {};

  const { relationshipField } = opts || {};

  return relationshipField;
}

class RelationshipInput extends Component {
  constructor(props) {
    super(props);
    this.loadOptions = this.loadOptions.bind(this);
    this.state = { options: [] };
  }
  componentDidMount() {
    const relationshipType = getRelationshipType(this.props.field)

    if (!relationshipType) return;
    
    this.loadOptions();
  }
  componentDidUpdate(prevProps) {
    const relationshipType = getRelationshipType(this.props.field);
    const prevRelationshipType = getRelationshipType(prevProps.field);

    if (relationshipType === prevRelationshipType) return;

    this.loadOptions();
  }
  async loadOptions() {
    const type = getRelationshipType(this.props.field);
    const relationshipField = getRelationshipField(this.props.field);
    try {
      const results = await getAssetsByType({ type });
  
      const options = (results || [])
        .filter(r => !!r.data[relationshipField])
        .map(r => ({
          value: r.assetParentId,
          label: r.data[relationshipField]
        }));
  
      this.setState({ options });
    } catch (err) {
      // TODO handle error
    }
  }
  render() {
    const {
      input,
      label,
      type,
      meta,
      field,
      ...props
    } = this.props;
    const { options } = this.state;
    return (
      <FormGroup controlId={input.name} validationState={getValidationState(meta)}>
        {label && <ControlLabel>{label}</ControlLabel>}
        <div className="form-container">
          <ReactSelect
            {...props}
            options={options}
            value={input.value}
            onChange={input.onChange}
            onBlur={() => input.onBlur(input.value)}
            simpleValue
          />
          {meta.touched &&
            (meta.error || meta.warning) &&
            <FormError message={meta.error || meta.warning} />}
        </div>
      </FormGroup>
    )
  }
}

export default RelationshipInput;


// WEBPACK FOOTER //
// ./src/components/routes/assets/asset-form/RelationshipInput.js